var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 5.99992C3.33325 3.80003 3.33325 2.70009 4.01667 2.01667C4.70009 1.33325 5.80003 1.33325 7.99992 1.33325C10.1998 1.33325 11.2997 1.33325 11.9832 2.01667C12.6666 2.70009 12.6666 3.80003 12.6666 5.99992V9.99992C12.6666 12.1998 12.6666 13.2997 11.9832 13.9832C11.2997 14.6666 10.1998 14.6666 7.99992 14.6666C5.80003 14.6666 4.70009 14.6666 4.01667 13.9832C3.33325 13.2997 3.33325 12.1998 3.33325 9.99992V5.99992Z",
    stroke: "#626F86",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 12.6667H8.66659",
    stroke: "#626F86",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.33325L6.05933 1.68927C6.18792 2.46078 6.25221 2.84654 6.51679 3.08128C6.7928 3.32615 7.18407 3.33325 8 3.33325C8.81593 3.33325 9.2072 3.32615 9.4832 3.08128C9.7478 2.84654 9.81207 2.46078 9.94067 1.68927L10 1.33325",
    stroke: "#626F86",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPh);
export default __webpack_public_path__ + "static/media/ph.de52860247976d44080b44d6bba3068e.svg";
export { ForwardRef as ReactComponent };